import React from 'react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import FavouriteButtonStateless, {
	type Props,
} from '@atlassian/jira-favourite-button-stateless/src';
import { ACTIONS_CELL_PADDING } from '../constants';

export default function FavouriteCell(props: Props) {
	return (
		<FavouriteButtonTableWrapper>
			<FavouriteButtonStateless {...props} />
		</FavouriteButtonTableWrapper>
	);
}

FavouriteCell.defaultProps = {
	isFavourite: undefined,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FavouriteButtonTableWrapper = styled.div<any>({
	display: 'flex',
	justifyContent: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: `${ACTIONS_CELL_PADDING} 0`,
});
